import React from "react";
import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import DropDown from "../../../../core/DropDown";
import EditableLink from "../../../../core/EditableLink";
import SubmitControl from "../../../../core/SubmitControl";
import Tag from "../../../../core/Tag";

const AdditionalData = ({
  knowledgeCopyrights,
  validationRules,
  onChange,
  knowledgeItem,
  editable,
  onAddToTag,
  disableChanged,
  tagsChanged,
  onRemoveTag
}) => {
  return (
    <>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.knowledgeCopyright}</FormLabel>
        </Col>
        <Col sm="10">
          <FormGroup controlId="knowledgeCopyright">
            <DropDown
              value={knowledgeItem.knowledgeCopyright}
              options={knowledgeCopyrights.map(x => ({
                value: x,
                label: x.name
              }))}
              onChange={onChange}
              targetId={"knowledgeCopyright"}
              placeholder={labels.knowledgeCopyright}
              required={validationRules.knowledgeCopyright?.required}
              readOnly={!editable}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.note}</FormLabel>
        </Col>
        <Col sm="10">
          <FormGroup controlId="note">
            <SubmitControl
              as="textarea"
              title={labels.note}
              value={knowledgeItem.note}
              onChange={onChange}
              placeholder={labels.note}
              readOnly={!editable}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.uri}</FormLabel>
        </Col>
        <Col sm="10">
          <FormGroup controlId="uri">
            <EditableLink
              title={labels.uri}
              value={knowledgeItem.uri}
              changeLinkValue={onChange}
              placeholder={labels.uri}
              readOnly={!editable}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="2">
          <FormLabel className="Label">{labels.tags}</FormLabel>
        </Col>
        <Col sm="10">
          <Tag
            tags={knowledgeItem.tags}
            onChange={onChange}
            changed={tagsChanged}
            disableChanged={disableChanged}
            onRemoveClick={onRemoveTag}
          />
        </Col>
      </Row>
      {knowledgeItem.autoTags?.length ? (
        <Row style={{ marginTop: "10px" }}>
          <Col sm="2">
            <FormLabel className="Label">{labels.autoTags}</FormLabel>
          </Col>
          <Col sm="10">
            <Tag
              tags={knowledgeItem.autoTags}
              onAddClick={onAddToTag}
              disableInput
            />
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default AdditionalData;
